import React from 'react';
import Layout from '../../../components/Layout';
import Page from '../../../components/Page';
import fetch from '../../../core/fetch';

const query = `query getEditStaticPage ($id: Int!) {
  getEditStaticPage (id: $id) {
      id
      pageName
      content
      metaTitle
      metaDescription
      createdAt
      dynamicStaticPage {
        id
        staticPageId
        language
        metaTitle
        metaDescription
        content
      }
  }
}`;

export default async function action() {
    const resp = await fetch('/graphql', {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: query,
            variables: { id: 7 },
        }),
        credentials: 'include',
    });

    const { data } = await resp.json();

    return {
        title: data?.getEditStaticPage?.metaTitle,
        description: data?.getEditStaticPage?.metaDescription,
        chunk: 'termsOfService',
        component: <Layout><Page data={data?.getEditStaticPage} /></Layout>
    };
};